import { Slider, cn } from '@duck/ui'

type RateSliderProps = {
    totalPoints: number
    value?: number
    onChange: (value: number) => void
    disabled?: boolean
    className?: string
}

export const RateSlider = ({
    totalPoints,
    value,
    onChange,
    disabled,
    className,
}: RateSliderProps) => {
    const nextValue = Number.isFinite(value) ? (value as number) : 1
    const clampedValue = Math.min(Math.max(Math.round(nextValue), 1), totalPoints)

    return (
        <div className={cn('space-y-2', className)}>
            <div className="flex items-center justify-between text-xs font-medium uppercase text-muted-foreground">
                <span>1</span>
                <span>{totalPoints}</span>
            </div>
            <Slider
                min={1}
                max={totalPoints}
                step={1}
                className='cursor-pointer'
                value={[clampedValue]}
                onValueChange={(newValue) => {
                    const next = newValue[0] ?? 1
                    const normalizedValue = Math.min(
                        Math.max(Math.round(next), 1),
                        totalPoints
                    )
                    onChange(normalizedValue)
                }}
                disabled={disabled}
            />
        </div>
    )
}

